import Login from "./views/authentication/Login.vue";
import ForgotPassword from "./views/authentication/ForgotPassword.vue";
import CreateAccount from "./views/authentication/CreateUserCompany.vue";
import Dashboard from "@/views/Dashboard.vue";
import Offers from "@/views/Offers.vue";
import AddOffer from "@/views/AddOffer.vue";
import Friends from "@/views/Friends.vue";
import Membership from "@/views/Membership.vue";
import Profile from "@/views/Profile.vue";
import Terms from "@/views/Terms.vue";
import Notifications from "@/views/Dashboard.vue";
import ManageAccounts from "@/views/ManageUsers.vue";
import ManageAdmins from "@/views/ManageAdmins.vue";
import ManageOffers from "@/views/ManageOffers.vue";

import { Cookies as CookiesComponent } from "./views/Cookies.vue";

export default [
	{
		path: "/",
		name: "login",
		component: Login,
		meta: { gtm: "Login" },
	},
	{
		path: "*",
		name: "noPage",
		component: Login,
		meta: { gtm: "Login" },
	},
	{
		path: "/forgot_password",
		name: "forgot_password",
		component: ForgotPassword,
	},
	{
		path: "/create_account/*",
		name: "create_account",
		component: CreateAccount,
		meta: { gtm: "CreeazaCont" },
	},
	{
		path: "/cookies",
		name: "cookies",
		component: CookiesComponent,
		meta: { gtm: "Cookies" },
	},
	{
		path: "/home",
		name: "dashboard",
		component: Dashboard,
		meta: { gtm: "Dashboard" },
	},
	// {
	// 	path: "/company/search",
	// 	name: "company_search",
	// 	component: Company,
	// 	params: { menu: "search" },
	// },
	{
		path: "/offers",
		name: "offers",
		component: Offers,
		meta: { gtm: "Offers" },
	},
	{
		path: "/events",
		name: "events",
		component: Offers,
		meta: { gtm: "Events" },
	},
	{
		path: "/trainings",
		name: "trainings",
		component: Offers,
		meta: { gtm: "trainings" },
	},
	{
		path: "/friends",
		name: "friends",
		component: Friends,
		params: { menu: "friends" },
		meta: { gtm: "Friends" },
	},
	{
		path: "/membership",
		name: "membership",
		component: Membership,
		params: { menu: "membership" },
		meta: { gtm: "Membership" },
	},
	// {
	// 	path: "/customer/faq",
	// 	name: "customer_faq",
	// 	component: Company,
	// 	params: { menu: "faq" },
	// 	meta: { gtm: "FAQClient" },
	// },
	{
		path: "/profile",
		name: "profile",
		component: Profile,
		params: { menu: "profile" },
		meta: { gtm: "Profile" },
	},
	// {
	// 	path: "/customer/contact",
	// 	name: "customer_contact",
	// 	component: Company,
	// 	params: { menu: "contact" },
	// 	meta: { gtm: "ContactClient" },
	// },
	{
		path: "/terms",
		name: "terms",
		component: Terms,
		params: { menu: "terms" },
		meta: { gtm: "Terms" },
	},
	// {
	// 	path: "/customer/gdpr",
	// 	name: "customer_gdpr",
	// 	component: Company,
	// 	params: { menu: "gdpr" },
	// 	meta: { gtm: "GDPRClient" },
	// },
	{
		path: "/customer/notifications",
		name: "customer_notifications",
		component: Notifications,
		params: { menu: "notifications" },
		meta: { gtm: "Notificari" },
	},
	{
		path: "/manage_users",
		name: "manage_users",
		component: ManageAccounts,
		params: { menu: "manage accounts" },
		meta: { gtm: "Manage accounts" },
	},
	{
		path: "/manage_admins",
		name: "manage_admins",
		component: ManageAdmins,
		params: { menu: "manage admins" },
		meta: { gtm: "Manage admins" },
	},
	{
		path: "/manage_offers",
		name: "manage_offers",
		component: ManageOffers,
		params: { menu: "manage offers" },
		meta: { gtm: "Manage offers" },
	},
	{
		path: "/add_offer",
		name: "newOffer",
		component: AddOffer,
		meta: { gtm: "New Offer" },
	},
]